import { trackEvent } from '@patrianna/analytics'
import { intlnumberFormat, nextTick } from '@patrianna/shared-utils'
import { getTranslationFromJson } from '@patrianna/shared-utils/prismic'
import { InformationOutline } from '@patrianna-icons/material-icons'
import cx from 'classnames'
import { useRouter } from 'next/navigation'

import LoyaltyProgressBar from 'components/LoyaltyProgressBar'
import ROUTES from 'config/routes.json'
import { LoyaltyStatus as LoyaltyStatusEnum } from 'containers/PulszPointsRewards/types'
import { getLoyaltyCardInfo } from 'containers/PulszPointsRewards/utils/getLoyaltyCardInfo'
import { getNextStatus } from 'containers/PulszPointsRewards/utils/getNextStatus'
import content from 'prismic-translates/page-pulsz-points.json'
import { useAppSelector } from 'store/hooks'
import {
  getCurrentVIPLevelPercentageSelector,
  getUserPulszPointsLevelSelector,
  getUserVipPointsLevelSelector,
} from 'store/modules/user/selectors'
import { useThemeContext } from 'theme/themeProvider'

import classes from './styles.module.scss'

const t = getTranslationFromJson([content])

type Props = {
  hideMenuCallback?: () => void
}

export default function LoyaltyStatus({ hideMenuCallback }: Props) {
  const router = useRouter()
  const { isDarkMode } = useThemeContext()
  const vipInformation = useAppSelector(getUserVipPointsLevelSelector)
  const progressPercent = useAppSelector(getCurrentVIPLevelPercentageSelector)
  const currentStatus = useAppSelector(getUserPulszPointsLevelSelector)
  const isIconStatus = currentStatus === LoyaltyStatusEnum.ICON

  if (!currentStatus) {
    return null
  }

  const nextStatus = getNextStatus(currentStatus)
  const { imageUrl: currentStatusImg, alt: currentStatusAlt } = getLoyaltyCardInfo(currentStatus)
  const { imageUrl: nextStatusImg, alt: nextStatusAlt } = getLoyaltyCardInfo(nextStatus)

  const handleInfoClick = () => {
    trackEvent('main_menu_loyalty_progress_click')
    if (hideMenuCallback) {
      nextTick().then(() => {
        hideMenuCallback()
        router.push(ROUTES.PULSZ_POINTS)
      })
    } else {
      router.push(ROUTES.PULSZ_POINTS)
    }
  }

  return (
    <div className={cx(classes.root, isDarkMode && classes.isDarkMode)}>
      <div className={classes.header}>
        <span>
          {t('pulsz_points')}{' '}
          <b className={classes.pulszPointsValue}>{intlnumberFormat(vipInformation.current, 'en-US')}</b>
        </span>
        <InformationOutline className={classes.infoIcon} onClick={handleInfoClick} />
      </div>
      <div className={classes.progressContainer} onClick={handleInfoClick}>
        <img src={currentStatusImg} alt={currentStatusAlt} className={classes.badge} loading='lazy' />
        <LoyaltyProgressBar
          progressPercent={progressPercent}
          className={cx(classes.progressBar, isIconStatus && classes.fixedWidth)}
        />
        {!isIconStatus && <img src={nextStatusImg} alt={nextStatusAlt} className={classes.badge} loading='lazy' />}
      </div>
      <div className={classes.footer}>
        <span>
          {t('status')}: <span className={classes.statusText}>{currentStatus}</span>
        </span>
        {!isIconStatus && (
          <span>
            {t('next')}: <span className={classes.statusText}>{nextStatus}</span>
          </span>
        )}
      </div>
    </div>
  )
}
